export default __webpack_public_path__ + "static/media/icon-dashboard.1a6f0ffa.svg";